import React, { useEffect, useState } from "react";
import AdminPartnerClient from "../../../Service/Admin/partner_services";
import Header from "./header";
import { useDispatch, useSelector } from "react-redux";
import { Document, Page } from "react-pdf";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import CircularIndeterminate from "../../../Components/Loader";
import {
  makeStyles,
  Grid,
  InputLabel,
  Typography,
  Box,
  Button,
} from "@material-ui/core";
import CustomInput from "../../../Components/CustomInput";
import DateComponent from "../../../Components/FormGenerator/datepicker_component";
import DataClient from "../../../Service/general_data_service";
import { GLOBAL_STEPPER_DATA } from "../../../Redux/actions";
const useStyles = makeStyles((theme) => ({
  labelText: {
    color: "#4D4F5C",
    fontSize: "16px",
    lineHeight: "22px",
  },
}));
function NDA(props: any) {
  const classes = useStyles();
  const data = {
    sender_name: "Simon Coops",
    send_date: "",
    recipient_name: "",
    recipient_date: "",
  };

  const global_data = useSelector((state: any) => state.stepperReducer);
  const [pdfData, setPdfData]: any = useState({});
  const [numPages, setNumPages] = useState(null);
  const [pageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(data);
  const [partnerNDAFlag, setPartnerNDAFlag] = useState(false);

  const dispatch = useDispatch();
  const [NDAFormError, setNDAFormError] = useState({
    sender_name: false,
    send_date: false,
    recipient_name: false,
    recipient_date: false,
  });

  //    const globaluserData = useSelector((state) => state.commonReducer);
  //    const role = globaluserData?.role;
  let role = sessionStorage.getItem("role");

  const setInputState = (inputStateValue: any, inputId: any) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
    setNDAFormError((prev) => {
      return { ...prev, [inputId]: false };
    });
  };
  // @ts-ignore
  const globaluserData = useSelector((state) => state.commonReducer);
  const loginRole = globaluserData?.role;
  // let loginRole = sessionStorage.getItem("role");
  console.log("loginRole", loginRole);
  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    AdminPartnerClient.Nda_get({
      partner_profile_id: global_data.partner_profile,
    })
      .then((response: any) => {
        console.log(response);
        setPdfData(response);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });

    DataClient.getData(
      "partner_ndas/fetch_nda?partner_profile_id=" + global_data.partner_profile
    )
      .then((response: any) => {
        console.log(response);
        response.partner_nda && setUserData(response.partner_nda);
        setPartnerNDAFlag(response.partner_nda ? true : false);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        dispatch(showSnackbar("error", [error.errors]));
      });
  }, []);

  const onSubmit = () => {
    setLoading(true);

    AdminPartnerClient.ndA_wwa_send({
      partner_profile_id: global_data.partner_profile,
      nda_submitted: true,
      wwa_submitted: false,
    })
      .then((response: any) => {
        if (response.data.id) {
          dispatch(showSnackbar("Success", ["Nda submit successfully"]));
          dispatch({
            type: GLOBAL_STEPPER_DATA,
            payload: { partner_nda_id: response.data.id },
          });

          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        dispatch(showSnackbar("error", [error.errors]));
      });

    props.parentHandleNext(props.activeIndex + 1);
  };

  const saveToAcuity = () => {
    console.log(userData, "userdata");
    let blockRequest = false;
    if (loginRole === "admin") {
      if (userData.sender_name === "") {
        setNDAFormError((prev: any) => {
          return { ...prev, sender_name: true };
        });
        blockRequest = true;
      }
      if (userData.send_date === null || userData.send_date === "") {
        setNDAFormError((prev: any) => {
          return { ...prev, send_date: true };
        });
        blockRequest = true;
      }
    } else if (loginRole === "partner") {
      if (userData.recipient_date === null || userData.recipient_date === "") {
        setNDAFormError((prev: any) => {
          return { ...prev, recipient_date: true };
        });
        blockRequest = true;
      }
      if (userData.recipient_name === "") {
        setNDAFormError((prev: any) => {
          return { ...prev, recipient_name: true };
        });
        blockRequest = true;
      }
    }
    if (blockRequest) {
      return;
    } else {
      setLoading(true);

      if (partnerNDAFlag) {
        DataClient.update(
          { partner_profile_id: global_data.partner_profile, ...userData },
          "partner_ndas/update_nda"
        )
          .then((response: any) => {
            dispatch(
              showSnackbar("Success", ["Data updated to acuity successfully"])
            );
            setLoading(false);
            onSubmit();
          })
          .catch((error) => {
            setLoading(false);
            dispatch(showSnackbar("error", [error.errors]));
          });
      } else {
        DataClient.create(
          { partner_profile_id: global_data.partner_profile, ...userData },
          "partner_ndas"
        )
          .then((response: any) => {
            dispatch(
              showSnackbar("Success", ["Data submit to acuity successfully"])
            );
            setLoading(false);
            onSubmit();
          })
          .catch((error) => {
            setLoading(false);
            dispatch(showSnackbar("error", [error.errors]));
          });
      }
    }
  };
  const onBack = () => {
    props.parentHandleNext(props.activeIndex - 1);
  };

  return (
    <>
      <iframe
        title="file"
        style={{ width: "100%", height: "calc(100vh - 400px)" }}
        src={pdfData.url}
      />
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ padding: 30, paddingBottom: 0 }}
        spacing={2}
      >
        <Grid item xs={4}>
          <Box mb={3} fontWeight="fontWeightBold">
            <Typography
              variant="subtitle1"
              className={classes.labelText}
              style={{ color: "#991A1E" }}
            >
              For and on behalf of The Discloser{" "}
            </Typography>
          </Box>
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant="h2">Name</Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                disabled={loginRole === "partner" ? true : false}
                id="sender_name"
                variant="outlined"
                placeholder="Name"
                parentcall={setInputState}
                value={userData.sender_name}
                required
                error={NDAFormError.sender_name}
                helperText={
                  NDAFormError.sender_name ? "Please enter a valid name" : ""
                }
              />
            </Grid>
          </Grid>
          <Grid container direction="row" alignItems="center">
            <Grid item xs={4}>
              <Typography variant="h2">Date</Typography>
            </Grid>
            <Grid item xs={8}>
              <DateComponent
                disabled={loginRole === "partner" ? true : false}
                key={"011"}
                componentObject={{
                  componentType: "datePicker",
                  required: true,
                  label: "",
                  name: "send_date",
                  placeholder: "DD/MM/YYYY",
                  helperText: NDAFormError.send_date
                    ? "Please select a valid date"
                    : false,
                  indexKey: "0-1",
                  index: "send_date",
                  handleChange: setInputState,
                  disabled: loginRole === "partner" ? true : false,
                  value: userData.send_date,
                  error: NDAFormError.send_date,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={4}>
          <Box mb={3} fontWeight="fontWeightBold">
            <Typography variant="subtitle1" style={{ color: "#991A1E" }}>
              The Recipient
            </Typography>
          </Box>
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant="h2">Name</Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                disabled={loginRole === "admin" ? true : false}
                id="recipient_name"
                variant="outlined"
                placeholder="Name"
                parentcall={setInputState}
                value={userData.recipient_name}
                helperText={
                  NDAFormError.recipient_name
                    ? "Please enter a valid name"
                    : false
                }
                error={NDAFormError.recipient_name}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" alignItems="center">
            <Grid item xs={4}>
              <Typography variant="h2">Date</Typography>
            </Grid>
            <Grid item xs={8}>
              <DateComponent
                disabled={loginRole === "admin" ? true : false}
                key={"011"}
                componentObject={{
                  componentType: "datePicker",
                  required: true,
                  label: "",
                  name: "recipient_date",
                  placeholder: "DD/MM/YYYY",
                  helperText: NDAFormError.recipient_date
                    ? "Please select a valid date"
                    : false,
                  indexKey: "0-1",
                  index: "recipient_date",
                  handleChange: setInputState,
                  disabled: loginRole === "admin" ? true : false,
                  value: userData.recipient_date,
                  error: NDAFormError.recipient_date,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Header
        isBack={true}
        saveBtnTitle={
          loginRole == "admin" ? "Save and Send NDA" : "Submit to Acuity"
        }
        parentcall={saveToAcuity}
        parentBackCall={onBack}
      />
      {loading && <CircularIndeterminate />}
    </>
  );
}

export default NDA;
